//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbFacebookLogin from '@/elements/facebook-login/facebook-login.vue'
import RbForgotPasswordForm from '@/elements/login-register/forms/rb-forgot-password-form.vue'
const RbLoading = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loading/rb-loading.vue')

import { mapActions, createNamespacedHelpers, mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import {
  ACTION_LOG_IN,
  ACTION_CHANGE_PRIVATE_SALES_FORMS_STATUS,
} from '@/scripts/store/actions/pdp'

import {
  ACTION_LOAD_USER,
  ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG,
} from '@/scripts/store/actions'

const { mapActions: mapActionsPdp, mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')
import wcs from '@/scripts/libs/wcs'
import md5 from 'md5'

import { WcsLogin } from '@/scripts/libs/wcs/login'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'rb-login-form',
  components: {
    RbForgotPasswordForm,
    RbLoading,
    RbFacebookLogin,
  },

  props: {
    isFrameAdvisor: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      password: '',
      emailAddress: '',
      submitted: false,
      response: false,
      error: false,
      errorMessage: false,
      createAccountLink: wcs.getEndPoint('createAccountUrl'),
      forgotPasswordLink: wcs.getEndPoint('forgotPasswordUrl'),
      dataFb: {},
      socialLoginEnabled: false,
      showForgotPasswordForm: false,
    }
  },
  validations: {
    emailAddress: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapGettersPdp([
      'ui',
      'selectedProduct',
      'privateSale',
      'selectedRoxOpticLens',
      'isEyeMedApplied',
      'benefits',
    ]),
    isSocialLoginEnabled() {
      return this.socialLoginEnabled
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
  },
  mounted() {
    const { facebookLogin } = wcs.getStoreConfig()
    this.socialLoginEnabled = facebookLogin
  },
  methods: {
    ...mapActions({
      loadUserData: ACTION_LOAD_USER,
      addProductAndCorrelatedToShoppingBag: ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG,
    }),
    ...mapActionsPdp({
      logIn: ACTION_LOG_IN,
      changePrivateSalesFormsStatus: ACTION_CHANGE_PRIVATE_SALES_FORMS_STATUS,
    }),
    updateFieldsFromFbLogin(dataFb) {
      if (dataFb.userData.isLogged) {
        this.dataFb = dataFb
        this.$refs.submit.click()
      }
    },
    toggleForgotPasswordForm() {
      this.showForgotPasswordForm = !this.showForgotPasswordForm
      this.$ma.trackEvent({
        event: 'Click',
        value: {
          data_element_id: 'X_X_LoginPanel_ForgotPassword',
        },
      })
    },
    showRegisterForm() {
      this.$emit('showRegisterForm')
      this.$ma.trackEvent({
        event: 'Click',
        value: {
          data_element_id: 'X_X_LoginPanel_CreateAccount',
        },
      })
    },
    handleClose() {
      this.password = ''
      this.emailAddress = ''
      this.submitted = false
      this.response = false
      this.$emit('close')
    },
    fbLoginAnalyticsTracking() {
      this.$ma.trackEvent({
        event: 'Click',
        value: {
          data_element_id: 'X_X_LoginPanel_Facebook',
        },
      })
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid || this.dataFb.userData.isLogged === true) {
        this.submitted = true
        WcsLogin.submitLogonForm({
          logonEmail: this.emailAddress,
          logonPassword: this.password,
          dataFb: this.dataFb,
        }).then((response) => {
          if (response.error) {
            this.error = response.error

            if (response.errorMessage) {
              this.errorMessage = response.errorMessage
            } else {
              this.errorMessage = 'Login Error'
            }

            this.submitted = false

            if (this.dataFb.userData?.isLogged === true) {
              this.$refs.btnFb.onLogoutFacebook()
            }
          } else {
            this.logIn()
            this.loadUserData()
            this.submitted = false

            let md5Email = undefined
            if (this.dataFb && this.dataFb.userData && this.dataFb.userData.email) {
              md5Email = md5(this.dataFb.userData.email)
            } else if (this.emailAddress) {
              md5Email = md5(this.emailAddress)
            }

            let userId = undefined
            if (this.dataFb && this.dataFb.userData && this.dataFb.userData.userId) {
              userId = this.dataFb.userData.userId
            }
            this.$ma.trackEvent({
              event: 'Login',
              value: {
                User_LoginType: 'Standard',
                User_Email_MD5: md5Email,
                User_Id: userId,
              },
            })
            this.handleClose()
            if (!this.isFrameAdvisor) {
              this.addProductAndCorrelatedToShoppingBag({
                selectedProduct: this.selectedProduct,
                selectedRoxOpticLens: this.selectedRoxOpticLens,
                isEyeMedApplied: this.isEyeMedApplied,
                benefits: this.benefits,
              })
            }
          }
        })
      }
      this.$ma.trackEvent({
        event: 'Click',
        value: {
          data_element_id: 'X_X_LoginPanel_Standard',
        },
      })
    },
  },
}
